module.exports = __webpack_public_path__ + "static/media/wavy_line_green.16100ae8.svg";